import { render, staticRenderFns } from "./receipt-detail-dialog.vue?vue&type=template&id=3367a1fe&scoped=true"
import script from "./receipt-detail-dialog.ts?vue&type=script&lang=ts&external"
export * from "./receipt-detail-dialog.ts?vue&type=script&lang=ts&external"
import style0 from "./receipt-detail-dialog.scoped.scss?vue&type=style&index=0&id=3367a1fe&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3367a1fe",
  null
  
)

export default component.exports